<template>
  <div class="gx-dy-plugin">
    <span class="gx-dy-plugin__label">观星树运营插件状态：</span>
    <button
      type="button"
      class="gx-dy-plugin__button"
      :class="`gx-dy-plugin__button--${status}`"
      :title="statusText"
      aria-label="观星树运营插件状态"
      @click.stop="handleClick"
    >{{ statusText }}</button>
    <section v-if="modal" class="gx-dy-plugin__modal" role="dialog" aria-modal="true" aria-label="浏览器插件状态" @click.stop>
      <button type="button" class="gx-dy-plugin__close" aria-label="关闭" @click="modal = ''">×</button>
      <h2>{{ modal === 'install' ? '插件下载' : modal === 'offline' ? '插件不在线' : '抖音未登录' }}</h2>
      <p>{{ modal === 'install' ? '插件尚未安装，为了更好的体验，请尽快下载安装！' : modal === 'offline' ? '观星树运营插件当前不在线，请确认插件已开启后刷新页面。' : '请先在浏览器中登录抖音后再使用DY链接任务' }}</p>
      <button type="button" @click="modal === 'install' ? goPluginInstall() : modal = ''">{{ modal === 'install' ? '点击安装' : '我知道了' }}</button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DyPluginStatus',
  data() {
    return {
      status: 'checking', modal: '', modalStatus: '',
      timer: null, probePending: false, probeListener: null, probeTimeout: null
    }
  },
  computed: {
    statusText() {
      return ({ready: '运行中', offline: '未运行', dy_logged_out: 'DY未登录', undetected: '未安装', checking: '检测中'})[this.status] || '检测中'
    }
  },
  mounted() {
    this.checkPlugin()
    this.timer = window.setInterval(this.checkPlugin, 10000)
    window.addEventListener('focus', this.checkPlugin)
  },
  beforeDestroy() {
    window.clearInterval(this.timer)
    window.clearTimeout(this.probeTimeout)
    if (this.probeListener) window.removeEventListener('message', this.probeListener)
    window.removeEventListener('focus', this.checkPlugin)
  },
  methods: {
    checkPlugin() {
      if (window.__isGxsExtensionInstalled__ === false) {
        this.status = 'undetected'
        this.openStatusModal()
        return
      }
      if (window.__isGxsExtensionInstalled__ === true) {
        window.clearTimeout(this.probeTimeout)
        if (this.probeListener) window.removeEventListener('message', this.probeListener)
        this.probeListener = null
        this.probePending = false
      }
      if (this.probePending) return
      this.probePending = true
      const clearProbe = () => {
        window.clearTimeout(this.probeTimeout)
        window.removeEventListener('message', this.probeListener)
        this.probeListener = null
        this.probePending = false
      }
      this.probeListener = (event) => {
        if (event.source !== window || !event.data || !['xingjieliu_content', 'xingjieliu_check_online_result'].includes(event.data.source) || event.data.type !== 'ONLINE_RESULT') return
        const result = event.data.data || {}
        const online = result.data || result
        this.status = result.success === false || online.online !== true ? 'offline' : online.loggedIn !== true ? 'dy_logged_out' : 'ready'
        this.openStatusModal()
        clearProbe()
      }
      window.addEventListener('message', this.probeListener)
      this.probeTimeout = window.setTimeout(() => {
        this.status = window.__isGxsExtensionInstalled__ === true ? 'offline' : 'undetected'
        this.openStatusModal()
        clearProbe()
      }, 3000)
      window.postMessage({ source: 'demo_page', type: 'xingjieliu_check_online' }, '*')
    },
    openStatusModal() {
      const nextModal = this.status === 'undetected' ? 'install' : this.status === 'offline' ? 'offline' : this.status === 'dy_logged_out' ? 'dy_logged_out' : ''
      if (!nextModal) {
        this.modal = ''
        this.modalStatus = ''
        return
      }
      if (this.modalStatus !== this.status) {
        this.modalStatus = this.status
        this.modal = nextModal
      }
    },
    handleClick() {
      // 运行中点击不再展开任务面板，仅异常状态点击时给出提示
      if (this.status === 'ready') return
      this.openStatusModal()
    },
    goPluginInstall() {
      this.modal = ''
      this.$router.push({path: '/new_system_workbench', query: {menu: 'software'}}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.gx-dy-plugin { position: relative; display: inline-flex; align-items: center; flex: 0 0 auto; gap: 4px; margin-left: auto; color: #667085; font-size: 13px; }
.gx-dy-plugin__label { white-space: nowrap; }
.gx-dy-plugin__button { height: 28px; padding: 0 8px; border: 0; border-radius: 5px; background: transparent; color: #1769d1; cursor: pointer; font: inherit; }
.gx-dy-plugin__button--undetected, .gx-dy-plugin__button--offline { color: #d4380d; }
.gx-dy-plugin__button--dy_logged_out { color: #d48806; }
.gx-dy-plugin__button--checking { color: #98a2b3; cursor: default; }
.gx-dy-plugin__button:hover:not(.gx-dy-plugin__button--checking) { background: #f1f6ff; }
.gx-dy-plugin__modal { position: absolute; top: 35px; right: 0; z-index: 320; border: 1px solid #e1e5ee; background: #fff; box-shadow: 0 12px 30px rgba(26, 26, 46, .2); color: #1a1a2e; }
.gx-dy-plugin__modal { width: min(320px, calc(100vw - 24px)); padding: 16px; border-radius: 10px; }
.gx-dy-plugin__modal h2 { margin: 0; font-size: 16px; font-weight: 600; }
.gx-dy-plugin__modal p { margin: 10px 0 14px; color: #667085; font-size: 13px; line-height: 1.6; }
.gx-dy-plugin__modal > button:not(.gx-dy-plugin__close) { float: right; min-width: 88px; height: 30px; border: 0; border-radius: 6px; background: #1677ff; color: #fff; font-size: 13px; cursor: pointer; }
.gx-dy-plugin__close { position: absolute; top: 6px; right: 8px; border: 0; background: transparent; color: #667085; font-size: 20px; cursor: pointer; }
</style>
